<template>
  <div>
    <v-stepper alt-labels v-model="currentStep" class="nv-stepper">
      <v-stepper-header class="AccountCreateStepperHeader">
        <v-stepper-step
            v-for="stepItem in visibleSteps"
            :key="stepItem.index"
            :stepper-index="stepItem.index"
            class="AccountCreateStepper"
            :class="stepState(stepItem.index)"
            color="white"
            complete
            :step="stepItem.step"
            complete-icon="">
          <span class="nv-step__icon">
            <v-icon>{{ stepState(stepItem.index) === 'is-complete' ? 'mdi-check' : stepItem.icon }}</v-icon>
          </span>
          <span class="nv-step__label">{{ stepItem.label }}</span>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="AccountCreateStepperCard">
        <v-stepper-content step="1">
          <v-form lazy-validation ref="modules">
            <v-row>
              <v-col class="col-12" v-if="isCreateNewBranch">
                <label class="nv-label">Şube Adı</label>
                <v-text-field
                    v-model="companyInfo.BranchName"
                    maxLength="50"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required,rules.IsCenter]"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">{{
                    companyInfo.TaxNumber && companyInfo.TaxNumber.length == 10 ? 'Vergi Kimlik No' : 'T.C. Kimlik No'
                  }}</label>
                <v-text-field
                    :value="companyInfo.TaxNumber"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details
                    disabled
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">{{
                    companyInfo.TaxNumber && companyInfo.TaxNumber.length == 10 ? 'Firma Ünvanı' : 'Ad Soyad'
                  }}</label>
                <v-text-field
                    v-model="companyInfo.Name"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required, _companyNameCheck || 'Lütfen Geçerli Bir Ad Soyad Giriniz! Ad Soyad Arasında Bir Boşluk Olmalıdır.']"
                    :disabled="!isCreateNewBranch"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">Modüller</label>
                <v-autocomplete
                    v-model="selectedModules"
                    :rules="[value => !!value.length != 0 || 'Boş Geçilemez']"
                    class="AccountCreateInput font-weight-bold"
                    chips
                    :items="modules"
                    item-text="Description"
                    item-value="Name"
                    solo
                    multiple
                    dense
                    hide-details="auto"
                    no-data-text="Modül Bulunamadı">
                  <template v-slot:selection="data">
                    <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item)"
                    >
                      {{ modules.find(x => x.Name == data.item.Name).Description }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">Bayi Kodu</label>
                <div class="d-flex">
                  <v-text-field
                      v-if="dealerCodeCheckBoxStatus"
                      v-model="companyInfo.DealerCode"
                      :rules="[rules.required,dealerCodeValidCounter != 0 || 'Bayi Kodunun Geçerlilik Durumunu Sorgulamayı Unutmayınız.',
                               value => value && dealerCodeValidStatus || 'Geçerli Bir Bayi Kodu Giriniz.']"
                      @input="companyInfo.DealerCode = companyInfo.DealerCode.toUpperCase()"
                      class="AccountCreateInput font-weight-bold"
                      solo
                      dense
                      hide-details="auto"
                      @keyup="DealerCodeValid(companyInfo.DealerCode)"
                  >
                  </v-text-field>
                  <v-text-field
                      v-else
                      disabled
                      class="AccountCreateInput"
                      solo
                      dense
                      hide-details
                  >
                  </v-text-field>
                  <v-btn :loading="dealerCodeValidLoading" :disabled="dealerCodeValidLoading || !companyInfo.DealerCode"
                         color="secondary" depressed class="nv-btn nv-btn--query ml-2" @click="DealerCodeStatus()">
                    <v-icon small left>mdi-magnify</v-icon>
                    Sorgula
                  </v-btn>
                </div>
                <span v-if="dealerCodeValidStatus" class="nv-valid"><v-icon
                    small color="success"
                    class="mr-1">mdi-check-circle</v-icon>Bayi Kodu Kullanım İçin Uygundur.</span>
                <v-checkbox v-model="dealerCodeCheckBoxStatus" class="checkbox-label"
                            label="Bayi Kodu Girilsin"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2" v-if="!companyInfo.IsExist">
          <v-form lazy-validation ref="addressInfo">
            <v-row @keydown.ctrl.shift.v.prevent="fillFields()">
              <v-col class="col-12">
                <div class="nv-callout">
                  <v-icon small color="secondary">mdi-information-outline</v-icon>
                  <span>{{
                      companyInfo.TaxNumber && companyInfo.TaxNumber.length == 10 ? 'Firmaya' : 'Kişiye'
                    }} Ait Adres Bilgileri Girilmelidir. Bu Bilgiler Fatura/Makbuz Üzerinde Görünecektir.</span>
                </div>
              </v-col>
              <v-col class="col-12">
                <label class="nv-label">Adres</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.Address"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">İlçe</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.District"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Şehir</label>
                <v-autocomplete
                    autocomplete="nope"
                    v-model="companyInfo.Address.City"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :items="cities"
                    item-value="value"
                    item-text="value"
                    :rules="[rules.required]"
                    no-data-text="Şehir Bulunamadı"
                ></v-autocomplete>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Ülke</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.Country"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]"
                    readonly
                ></v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Posta Kodu</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.PostalCode"
                    class="AccountCreateInput iconRemove font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[value => !value || value.length > 4 || 'Boş Geçilemez']"
                    type="number"
                    v-mask="'#####'"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Telefon Numarası</label>
                <v-text-field
                    :key="phoneNumberKey"
                    autocomplete="nope"
                    v-model="companyPhone"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    v-mask="'0 (###) ### ## ##'"
                    :rules="[rules.required,rules.phone]"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Fax</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.Fax"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details
                    maxLength="15"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Vergi Dairesi</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.TaxOffice"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]">
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">Web Site Adresi</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.WebSite"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-4">
                <label class="nv-label">E-Posta</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.Address.Email"
                    :rules="[rules.required,rules.emailRules]"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto">
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3" v-if="!companyInfo.IsExist || !creationInfo.IsThereUser">
          <v-form lazy-validation ref="userInfo">
            <v-row>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">Ad</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.User.Name"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]"
                    tabindex="1"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">Soyad</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="companyInfo.User.Surname"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    :rules="[rules.required]"
                    tabindex="2"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">E-Posta</label>
                <div class="d-flex">
                  <v-text-field
                      autocomplete="nope"
                      v-model="companyInfo.User.Email"
                      :rules="[rules.required,
                      rules.mailValidControl,
                      mailValidCounter != 0 || 'E-Posta Adresinin Geçerlilik Durumunu Sorgulamayı Unutmayınız.',
                      rules.IsThereMail]"
                      class="AccountCreateInput font-weight-bold"
                      solo
                      dense
                      hide-details="auto"
                      @keyup="MailValid(companyInfo.User.Email)"
                      tabindex="3"
                  >
                  </v-text-field>

                  <v-btn :loading="mailValidLoading" :disabled="mailValidLoading || !mailQueryValid"
                         color="secondary" depressed
                         class="nv-btn nv-btn--query ml-2" @click="MailStatus()">
                    <v-icon small left>mdi-magnify</v-icon>
                    Sorgula
                  </v-btn>
                </div>
                <span v-if="mailValidStatus" class="nv-valid"><v-icon
                    small color="success"
                    class="mr-1">mdi-check-circle</v-icon>E-Posta Adresi Kullanım İçin Uygundur.</span>
              </v-col>
              <v-col class="col-12 col-md-6">
                <label class="nv-label">Telefon Numarası</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="userPhone"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                    v-mask="'0 (###) ### ## ##'"
                    :rules="[rules.phone]"
                    tabindex="4"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12">
                <div class="nv-callout">
                  <v-icon small color="secondary">mdi-email-lock</v-icon>
                  <span>Belirttiğiniz e-posta adresine şifreniz gönderilecektir. Şifrenizi sıfırlamak isterseniz, portal giriş ekranında yer alan 'Parolamı Unuttum' seçeneğine tıklayarak şifre sıfırlama bağlantısı alabilirsiniz.</span>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4"
                           v-if="selectedModules.includes('ESMM') || selectedModules.includes('EArchive')">
          <v-form lazy-validation ref="signer">
            <v-row>
              <v-col class="col-12">
                <div class="nv-callout">
                  <v-icon small color="secondary">mdi-information-outline</v-icon>
                  <span>Fatura ve Makbuz Tasarımlarında Olması Gereken Firma Yetkilisine Ait İmzayı Yüklemelisiniz. Mevzuata Göre e-Arşiv Fatura/e-SMM Üzerinde Firma Yetkilisine Ait İmza Görünmesi Gerekmektedir.</span>
                </div>
              </v-col>
              <v-col class="col-12">
                <ImageCrop @content="c=>{ signImageInfo = c }"></ImageCrop>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="5" v-if="selectedModules.includes('EInvoice')">
          <v-form lazy-validation ref="EInvoiceInfo">
            <v-row>
              <v-col class="col-12" v-if="aliasTypes.includes('GB')">
                <label class="nv-label">Gönderici Birim</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="AliasInfo.EInvoiceOption.SendingUnit"
                    :rules="[einvoiceAliasConfirmation(AliasInfo.EInvoiceOption.SendingUnit)]"
                    prefix="urn:mail:"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12" v-if="aliasTypes.includes('PK')">
                <label class="nv-label">Posta Kutusu</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="AliasInfo.EInvoiceOption.MailBox"
                    :rules="[einvoiceAliasConfirmation(AliasInfo.EInvoiceOption.MailBox)]"
                    prefix="urn:mail:"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="6" v-if="selectedModules.includes('EDespatch')">
          <v-form lazy-validation ref="EDespatchInfo">
            <v-row>
              <v-col class="col-12" v-if="aliasTypes.includes('GB')">
                <label class="nv-label">Gönderici Birim</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="AliasInfo.EDespatchOption.SendingUnit"
                    :rules="[edespatchAliasConfirmation(AliasInfo.EDespatchOption.SendingUnit)]"
                    prefix="urn:mail:"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                >
                </v-text-field>
              </v-col>
              <v-col class="col-12" v-if="aliasTypes.includes('PK')">
                <label class="nv-label">Posta Kutusu</label>
                <v-text-field
                    autocomplete="nope"
                    v-model="AliasInfo.EDespatchOption.MailBox"
                    :rules="[edespatchAliasConfirmation(AliasInfo.EDespatchOption.MailBox)]"
                    prefix="urn:mail:"
                    class="AccountCreateInput font-weight-bold"
                    solo
                    dense
                    hide-details="auto"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="7">
          <div class="nv-review">
            <div class="nv-review__head">
              <span class="nv-review__icon"><v-icon color="secondary">mdi-file-eye-outline</v-icon></span>
              <div>
                <h4 class="nv-card__title">Tasarım Önizleme</h4>
                <p class="nv-card__subtitle">Tasarımların Önizlemesini Aşağıdaki Butonları Kullanarak Sağlayabilirsiniz.</p>
              </div>
            </div>
            <div class="nv-preview-list">
              <button v-if="selectedModules.includes('EInvoice')" type="button" class="nv-preview" @click="previewTemplate('EInvoice')">
                <v-icon small>fa fa-file-contract</v-icon>
                <span>E-Fatura</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EArchive')" type="button" class="nv-preview" @click="previewTemplate('EArchive')">
                <v-icon small>fa fa-folder-open</v-icon>
                <span>E-Arşiv</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EDespatch')" type="button" class="nv-preview" @click="previewTemplate('EDespatch')">
                <v-icon small>fas fa-truck-moving</v-icon>
                <span>E-İrsaliye</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EDespatch')" type="button" class="nv-preview" @click="previewTemplate('EDespatchAnswer')">
                <v-icon small style="transform: scaleX(-1);">fa fa-reply-all</v-icon>
                <span>İrsaliye Yanıtı</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('ESMM')" type="button" class="nv-preview" @click="previewTemplate('ESMM')">
                <v-icon small>fa fa-briefcase</v-icon>
                <span>E-SMM</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EMM')" type="button" class="nv-preview" @click="previewTemplate('EMM')">
                <v-icon small>fa fa-tractor</v-icon>
                <span>E-MM</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EBill')" type="button" class="nv-preview" @click="previewTemplate('EBill')">
                <v-icon small>fas fa-concierge-bell</v-icon>
                <span>E-Adisyon</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('EInsurance')" type="button" class="nv-preview" @click="previewTemplate('EInsurance')">
                <v-icon small>fas fa-shield-alt</v-icon>
                <span>E-Sigorta</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
              <button v-if="selectedModules.includes('Expense')" type="button" class="nv-preview" @click="previewTemplate('Expense')">
                <v-icon small>fas fa-compass</v-icon>
                <span>E-Gider Pusulası</span>
                <v-icon x-small class="nv-preview__arrow">mdi-open-in-new</v-icon>
              </button>
            </div>
          </div>

          <div class="nv-callout mt-5">
            <v-icon small color="secondary">mdi-information-outline</v-icon>
            <span>Girmiş Olduğunuz Bilgilerde Herhangi Bir Eksiklik Yok İse 'Başvuruyu Onayla' Butonunu Kullanarak Başvurunuzu İletebilirsiniz.</span>
          </div>

          <div class="nv-approve">
            <div v-if="companyInfo.BranchName == 'Merkez'" class="nv-approve__contract">
              <v-checkbox class="checkbox-label pa-0 ma-0" v-model="contractCheckbox" color="secondary" hide-details dense></v-checkbox>
              <span><a class="nv-link" @click.prevent="contractModalOpen">Kullanıcı sözleşmesini</a> okudum, onaylıyorum</span>
            </div>
            <v-btn min-width="260" x-large depressed color="success" class="nv-btn nv-submit"
                   @click="AccountCreate()" :disabled="accountCreateLoading" :loading="accountCreateLoading">
              <v-icon left>mdi-send</v-icon>
              Başvuruyu Onayla
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
      <div class="nv-stepper__nav">
        <v-btn v-if="this.currentStep > 1" @click="previousStep" depressed large color="primary" class="nv-btn">
          <v-icon small left>mdi-arrow-left</v-icon>
          Önceki Adım
        </v-btn>
        <v-spacer></v-spacer>
        <span class="nv-stepper__counter">Adım {{ currentStepNumber }} / {{ visibleSteps.length }}</span>
        <v-btn v-if="this.currentStep < 7" @click="nextStep" :disabled="nextStepLoading" :loading="nextStepLoading"
               depressed large color="primary" class="nv-btn">
          Sonraki Adım
          <v-icon small right>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </v-stepper>

    <process-loading v-model="loadingDialog">
      <template v-slot:content>
        {{ loadingContent }}
      </template>
    </process-loading>

    <!--Önizleme Oluşturuldu-->
    <v-dialog
        v-model="previewModal"
        max-width="880px"
        scrollable
    >
      <v-card class="nv-dialog">
        <div class="nv-dialog__header">
          <span class="nv-dialog__icon"><v-icon color="secondary">mdi-file-eye-outline</v-icon></span>
          <h4 class="nv-dialog__title">{{ previewModalItem.Name }}</h4>
          <v-spacer></v-spacer>
          <v-btn icon small @click="previewModal = false" aria-label="Kapat">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <iframe
              ref="previewModal"
              :srcdoc="previewModalItem.HtmlDocument"
              name="previewModal"
              id="previewModal"
              width="100%"
              class="previewModalStyle"
              frameborder="0"
              scrolling="yes"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Contract v-if="contract" v-model="companyInfo" :selectedModules="selectedModules" :companyPhone="companyPhone"
              ref="contract"></Contract>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import ImageCrop from "@/view/pages/Signing/ImageCrop";
import activation from "@/core/services/Activation/action"
import gib from "@/core/services/GIB/action"
import {GET_ACCOUNT} from "@/core/services/store/profile.module";
import ProcessLoading from "@/view/content/ProcessLoading";
import cities from "@/core/config/other/cities";
import Contract from "@/view/pages/Signing/Contract";
import {AxiosRedirect} from "@/core/services/axios.redirect";

export default {
  name: "Create",
  components: {
    ImageCrop,
    ProcessLoading,
    Contract
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Boş Geçilemez',
        IsThereMail: value => value && this.mailValidStatus || 'E-Posta Kullanımdadır. Farklı Bir E-Posta Giriniz.',
        mailValidControl: value => /^(([a-zA-Z0-9.+*_-]+(\.[a-zA-Z0-9.+*_-]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Geçerli Bir E-Posta Giriniz.',
        IsCenter: value => (value && (value.trim() != 'Merkez' && value.trim() != 'merkez')) || 'Şube Adı Merkez Olamaz !',
        phone: value => (!value || value.replace(/[\s()]/g, '').length > 10) || 'Geçerli Bir Telefon Numarası Giriniz.',
        emailRules: value => !value || 'E-mail alanı zorunludur.' && /^(([a-zA-Z0-9.+*_-]+(\.[a-zA-Z0-9.+*_-]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Geçerli Bir E-Posta Giriniz.'
      },
      cities,
      companyInfo: {
        Name: null,
        TaxNumber: null,
        BranchName: null,
        Modules: [],
        Address: {
          Country: "Türkiye"
        },
        User: {
          Email: null
        },
        EInvoiceOption: null,
        EDespatchOption: null,
        EArchiveOption: null,
        ESMMOption: null,
      },
      AliasInfo: {
        EInvoiceOption: {},
        EDespatchOption: {},
      },
      signImageInfo: {
        imgSrc: "",
        cropImg: "",
        fileExtension: ""
      },
      nextStepLoading: false,
      isCreateNewBranch: false,
      NameCheck: true,
      selectedModules: [],
      previewModalItem: {},
      previewModal: false,
      dealerCodeCheckBoxStatus: false,
      accountCreateLoading: false,
      loadingDialog: false,
      loadingContent: null,
      mailValidLoading: false,
      mailValidStatus: false,
      mailValidCounter: 0,
      dealerCodeValidStatus: false,
      dealerCodeValidCounter: 0,
      dealerCodeValidLoading: false,
      currentMail: null,
      currentDealerCode: null,
      confirmPassIconShow: null,
      passIconShow: false,
      aliasTypes: ['PK', 'GB'],
      currentStep: '1',
      steps: ['1', '2', '3', '8'],
      modules: [],
      previewModules: [],
      phoneNumberKey: 0,
      companyPhone: null,
      userPhone: null,
      contract: false,
      contractCheckbox: false,
    }
  },
  methods: {
    toastSuccess(success) {
      this.$bvToast.toast(success, {
        toaster: 'b-toaster-bottom-right',
        title: 'Başarılı',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastSuccess-body",
        headerClass: "toastSuccess-header",
        toastClass: "toastSuccess-container"
      });
    },
    toastError(error) {
      this.$bvToast.toast(error, {
        toaster: 'b-toaster-bottom-right',
        title: 'Hata',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastError-body",
        headerClass: "toastError-header",
        toastClass: "toastError-container"
      });
    },
    previousStep() {
      this.steps = this.visibleSteps.map(x => x.index)
      let index = this.steps.indexOf(this.currentStep)
      this.currentStep = this.steps[index - 1]
    },
    stepState(stepIndex) {
      const order = this.visibleSteps.map(x => x.index)
      const current = order.indexOf(String(this.currentStep))
      const position = order.indexOf(stepIndex)
      if (position < current) return 'is-complete'
      if (position === current) return 'is-active'
      return ''
    },
    async nextStep() {
      let isValid = false
      switch (parseInt(this.currentStep)) {
        case 1:
          isValid = this.$refs.modules.validate();
          break;
        case 2:
          isValid = this.$refs.addressInfo.validate();
          break;
        case 3:
          isValid = this.$refs.userInfo.validate();
          break;
        case 4:
          isValid = this.signImageInfo.cropImg ? true : false;
          break;
        case 5:
          isValid = this.$refs.EInvoiceInfo.validate();
          break;
        case 6:
          isValid = this.$refs.EDespatchInfo.validate()
          break;
      }

      if (isValid) {
        if (this.currentStep == 1 && (this.creationInfo.BranchName == 'Merkez' || this.getAccount.IsExist === false) && ['EInvoice', 'EArchive', 'EDespatch'].find(x => this.selectedModules.includes(x))) {
          //Test ortamlarında bu kontrolü sağlamamak için Authority'e bakılıyor.
          const {Authority} = AxiosRedirect();
          if (Authority.includes('id.nilvera')) {
            this.nextStepLoading = true;
            const {status, data} = await gib.CheckGibAccount({vknTckn: this.companyInfo.TaxNumber})
            this.nextStepLoading = false;
            if (status === 200) {
              // const result = this.getPropertiesAsSmall(JSON.parse(data.result));
              if (!data.message.includes('irsaliye') && !data.message.includes('önceden') && !data.message.includes('güncel')) {
                this.toastError("E-Fatura Resmi Başvurusu Yapılmalıdır.");
                return;
              }
            } else {
              this.toastError("E-Fatura Resmi Başvuru Sorgulanırken Hata.");
              return;
            }
          }
        }
        this.steps = this.visibleSteps.map(x => x.index)
        let index = this.steps.indexOf(this.currentStep)
        this.currentStep = this.steps[index + 1]
      } else {
        this.toastError("Bir Sonraki Adım İçin Zorunlu Alanları Doldurunuz.")
      }
    },
    getPropertiesAsSmall(model) {
      const properties = Object.entries(model);
      return Object.fromEntries(
          properties.map(([key, value]) => [key.toLowerCase(), value])
      );
    },
    remove(item) {
      const index = this.selectedModules.indexOf(item.Name)
      if (index >= 0) this.selectedModules.splice(index, 1)
    },
    MailValid(val) {
      if (this.currentMail != val) {
        this.mailValidLoading = false
        this.mailValidStatus = false
        this.mailValidCounter = 0
      }
    },
    DealerCodeValid(val) {
      if (this.currentDealerCode != val) {
        this.dealerCodeValidLoading = false
        this.dealerCodeValidStatus = false
        this.dealerCodeValidCounter = 0
      }
    },
    async MailStatus() {
      //Eğer E-Posta Kullanım İçin Uygunsa mailValidStatus true değeri atılır.
      //Eğer E-Posta Kullanım İçin Uygun Değil ise mailValidStatus false değeri atılır
      if (this.mailQueryValid) {
        this.mailValidLoading = true
        this.currentMail = this.companyInfo.User.Email
        let response = await activation.CheckEmail(this.companyInfo.User.Email)
        if (response.status == 200) {
          this.mailValidStatus = response.data ? true : false
        } else {
          this.mailValidStatus = false
          response && response.data.Errors ? response.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError(`E-Posta Adresi Sorgulanırken Hata.`);
        }
        this.mailValidCounter += 1
        this.mailValidLoading = false
      }
    },
    async DealerCodeStatus() {
      this.currentDealerCode = this.companyInfo.DealerCode
      let response = await activation.CheckDealerCode(this.companyInfo.DealerCode)
      if (response.status == 200) {
        if (response.data) {
          this.dealerCodeValidStatus = true
        } else {
          this.dealerCodeValidStatus = false
          this.toastError("Böyle Bir Bayi Bulunmamaktadır.")
        }
      } else {
        this.dealerCodeValidStatus = false
        response && response.data.Errors ? response.data.Errors.forEach((error) => {
          this.toastError(error)
        }) : this.toastError(`Bayi Kodu Sorgulanırken Hata.`);
      }
      this.dealerCodeValidCounter += 1
    },
    async previewTemplate(module) {
      this.loadingContent = "Önizleme İşlemi Devam Etmektedir."
      this.loadingDialog = true
      let response = null
      let ModuleDesc = null
      this.previewModal = false
      this.previewModalItem = {}
      if (this.companyInfo.Address.hasOwnProperty('Address')) {
        this.companyInfo.Address.PhoneNumber = this.companyPhone ? this.companyPhone.replace(/[\s()]/g, '') : null
        this.companyInfo.User.PhoneNumber = this.userPhone ? this.userPhone.replace(/[\s()]/g, '') : null
      }
      switch (module) {
        case 'EInvoice':
          response = await activation.EInvoice(this.companyInfo)
          ModuleDesc = 'E-Fatura Tasarımı'
          break;
        case 'EArchive':
          response = await activation.EArchive(this.companyInfo)
          ModuleDesc = 'E-Arşiv Tasarımı'
          break;
        case 'EDespatch':
          response = await activation.EDespatch(this.companyInfo)
          ModuleDesc = 'E-İrsaliye Tasarımı'
          break;
        case 'EDespatchAnswer':
          response = await activation.EDespatchAnswer(this.companyInfo)
          ModuleDesc = 'İrsaliye Yanıtı Tasarımı'
          break;
        case 'ESMM':
          response = await activation.ESMM(this.companyInfo)
          ModuleDesc = 'E-SMM Tasarımı'
          break;
        case 'EMM':
          response = await activation.EMM(this.companyInfo)
          ModuleDesc = 'E-MM Tasarımı'
          break;
        case 'EBill':
          response = await activation.EBill(this.companyInfo)
          ModuleDesc = 'E-Adisyon Tasarımı'
          break;
        case 'EInsurance':
          response = await activation.EInsurance(this.companyInfo)
          ModuleDesc = 'E-Sigorta Tasarımı'
          break;
        case 'Expense':
          response = await activation.Expense(this.companyInfo)
          ModuleDesc = 'E-Gider Pusulası Tasarımı'
          break;
      }

      if (response.status == 200) {
        this.previewModalItem.Name = ModuleDesc
        this.previewModalItem.HtmlDocument = response.data
        this.previewModal = true
      } else {
        response && response.data.Errors ? response.data.Errors.forEach((error) => {
          this.toastError(error)
        }) : this.toastError(`${ModuleDesc} Önizlenirken Hata.`);
      }
      this.loadingDialog = false
    },
    async contractModalOpen() {
      await (this.contract = true)
      this.$refs.contract.contractModalOpen()
    },
    async AccountCreate() {
      this.accountCreateLoading = true;
      if (!this.contractCheckbox && this.companyInfo.BranchName == 'Merkez') {
        this.toastError("Lütfen Kullanıcı Sözleşmesini Onaylayınız.");
      } else {
        this.loadingContent = "Başvuru İşlemi Devam Etmektedir."
        this.loadingDialog = true
        this.AccountControl();
        this.companyInfo.CommonName = this.getCertificate.CommonName
        let response = await activation.AccountCreate(this.companyInfo)
        if (response.status == 200) {
          let Info = await activation.AccountInfo(this.companyInfo.TaxNumber)
          await this.$store.dispatch(GET_ACCOUNT, Info.data)
          if (Info.status == 200) {
            if (this.companyInfo.BranchName == 'Merkez') {
              await (this.contract = true)
              this.$refs.contract.contractDownload()
              return
            } else this.$router.push("/dashboard")
          } else {
            this.toastSuccess("Başvuru Onaylanmak Üzere Gönderim Kuyruğuna Eklendi. Giriş Ekranına Yönlendiriliyorsunuz.");
            response.data.Errors ? response.data.Errors.forEach((error) => {
              this.toastError(error)
            }) : this.toastError("Hesap Bilgisi Getirilirken Hata.");

            setTimeout(() => {
              this.$router.push("/login", () => {
              });
            }, 3000)
          }
        } else {
          response && response.data.Errors ? response.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError(`Başvuru Onaylanırken Hata.`);
        }
        this.loadingDialog = false
      }
      this.accountCreateLoading = false;
    },
    AccountControl() {

      if (this.selectedModules.includes('EInvoice')) {
        this.companyInfo.EInvoiceOption = {
          SendingUnit: 'urn:mail:' + this.AliasInfo.EInvoiceOption.SendingUnit,
          MailBox: 'urn:mail:' + this.AliasInfo.EInvoiceOption.MailBox
        }

        !this.AliasInfo.EInvoiceOption.SendingUnit && delete this.companyInfo.EInvoiceOption.SendingUnit
        !this.AliasInfo.EInvoiceOption.MailBox && delete this.companyInfo.EInvoiceOption.MailBox
      } else {
        this.companyInfo.EInvoiceOption = null
        !this.selectedModules.includes('EArchive') && (this.companyInfo.EArchiveOption = null)
        !this.selectedModules.includes('ESMM') && (this.companyInfo.ESMMOption = null)
      }

      if (this.selectedModules.includes('EDespatch')) {
        this.companyInfo.EDespatchOption = {
          SendingUnit: 'urn:mail:' + this.AliasInfo.EDespatchOption.SendingUnit,
          MailBox: 'urn:mail:' + this.AliasInfo.EDespatchOption.MailBox
        }

        !this.AliasInfo.EDespatchOption.SendingUnit && delete this.companyInfo.EDespatchOption.SendingUnit
        !this.AliasInfo.EDespatchOption.MailBox && delete this.companyInfo.EDespatchOption.MailBox
      } else {
        this.companyInfo.EDespatchOption = null
      }

      this.companyInfo.Modules = []
      this.selectedModules.forEach((module) => {
        this.companyInfo.Modules.push(this.modules.find(y => y.Name == module))
      })

      this.companyInfo.DealerCode = this.dealerCodeCheckBoxStatus ? this.companyInfo.DealerCode : null

      if (this.companyInfo.User?.Email) {
        this.companyInfo.User.PhoneNumber = this.userPhone ? this.userPhone.replace(/[\s()]/g, '') : null;
      } else {
        this.companyInfo.User = null;
      }

      if (!this.companyInfo.Address.hasOwnProperty('Address')) {
        this.companyInfo.Address = null;
      } else {
        this.companyInfo.Address.PhoneNumber = this.companyPhone ? this.companyPhone.replace(/[\s()]/g, '') : null;
      }
    },
    edespatchAliasConfirmation(value) {
      switch (true) {
        case !this.AliasInfo.EDespatchOption.SendingUnit && !this.AliasInfo.EDespatchOption.MailBox:
          return this.aliasTypeValidationMessage();
        case this.AliasInfo.EDespatchOption.SendingUnit == this.AliasInfo.EDespatchOption.MailBox:
          return 'Gönderici Birim ve Posta Kutusu Aynı Olamaz.';
        case value && value.length > 0 && value.length <= 90:
          return /^urn:mail:(([a-zA-Z0-9.+*_-]+(\.[a-zA-Z0-9.+*_-]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test('urn:mail:' + value) || 'Geçerli Bir Posta Kutusu Etiketi Giriniz.';
        case value && value.length > 90:
          return 'Maksimum Limite Ulaşıldı.'
        default:
          return true
      }
    },
    einvoiceAliasConfirmation(value) {
      switch (true) {
        case !this.AliasInfo.EInvoiceOption.SendingUnit && !this.AliasInfo.EInvoiceOption.MailBox:
          return this.aliasTypeValidationMessage();
        case this.AliasInfo.EInvoiceOption.SendingUnit == this.AliasInfo.EInvoiceOption.MailBox:
          return 'Gönderici Birim ve Posta Kutusu Aynı Olamaz.';
        case value && value.length > 0 && value.length <= 90:
          return /^urn:mail:(([a-zA-Z0-9.+*_-]+(\.[a-zA-Z0-9.+*_-]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test('urn:mail:' + value) || 'Geçerli Bir Posta Kutusu Etiketi Giriniz.';
        case value && value.length > 90:
          return 'Maksimum Limite Ulaşıldı.'
        default:
          return true
      }
    },
    aliasTypeValidationMessage() {
      return (this.aliasTypes.length === 2 ? 'Gönderici Birim veya Posta Kutusu' : this.aliasTypes[0] == 'PK' ? 'Posta Kutusu' : 'Gönderici Birim') + ' Boş Geçilemez';
    },
    async fillFields() {
      const customer = await navigator.clipboard.readText();
      let model = null;
      try {
        model = JSON.parse(customer);
      } catch {
        model = null;
      }
      if (model) {
        this.companyInfo.Address = {
          Address: model.Address,
          District: model.District,
          City: model.City,
          Country: "Türkiye",
          PostalCode: model.PostalCode,
          Fax: model.Fax,
          TaxOffice: model.TaxOffice,
          WebSite: model.WebSite,
          Email: model.Email,
          PhoneNumber: null,
        };
        this.companyPhone = model.PhoneNumber;
        this.phoneNumberKey++;
      }
    }
  },
  async created() {
    let creationInfo = this.creationInfo
    this.companyInfo.TaxNumber = this.getCertificate.SerialNumber
    if (creationInfo && creationInfo.Status) {
      if (creationInfo.Status == 'Module') {
        this.companyInfo.CompanyID = creationInfo.ID;
        this.companyInfo.IsExist = true;
        this.companyInfo.Name = creationInfo.Name.replace(/\s+/g, ' ').trim();
        this.companyInfo.Address = this.creationInfo.Address;
        this.companyInfo.BranchName = this.creationInfo.BranchName;
        let response = await activation.GetNonModules(creationInfo.ID)
        if (response.status == 200) {
          if (creationInfo.BranchName == 'Merkez') {
            this.modules = response.data
          } else {
            const modules = response.data.filter(x => !['EArchive', 'EMM', 'ESMM', 'EBill', 'EInsurance', 'ECurrency', 'Expense'].includes(x.Name))
            this.modules = modules.filter(x => this.headCompanyModules.find(({ID}) => x.ID == ID))
          }
        } else {
          this.$router.push("/dashboard")
        }
        document.title = 'Nilvera | Yeni Başvuru'
      } else if (creationInfo.Status == 'Branch') {
        this.modules = this.headCompanyModules
        if (this.modules.length > 0) {
          this.companyInfo.IsExist = false
          this.isCreateNewBranch = true
        }
        document.title = 'Nilvera | Şube Oluştur'
      } else if (creationInfo.Status == "Alias") {
        this.isCreateNewAlias = true;
        this.companyInfo.IsExist = true;
        this.companyInfo.CompanyID = creationInfo.ID;
        this.companyInfo.Name = creationInfo.Name.replace(/\s+/g, ' ').trim();
        this.modules = new Array(creationInfo.Module);
        this.selectedModules = Array.from(this.modules, ({Name}) => Name);
        this.aliasTypes = new Array(creationInfo.AliasType);
        document.title = 'Nilvera | Etiket Oluştur';
      } else {
        this.$router.push("/dashboard")
      }
    } else {
      if (!this.getAccount.IsExist) {
        let response = await activation.GetModules()
        if (response.status == 200) {
          this.modules = response.data
          this.companyInfo.IsExist = false
          this.companyInfo.Name = this.getCertificate.CommonName.replace(/\s+/g, ' ').trim();
          this.companyInfo.BranchName = 'Merkez'
        } else {
          this.$router.push("/login", () => {
          });
        }
      } else {
        this.$router.push("/login", () => {
        });
      }
      document.title = 'Nilvera | Firma Oluştur'
    }
  },
  computed: {
    ...mapGetters(["getAccount", "getCertificate", "creationInfo", "headCompanyModules"]),
    visibleSteps() {
      const steps = [{index: '1', step: '1', label: 'Modüller', icon: 'mdi-view-grid-plus'}]
      if (!this.companyInfo.IsExist)
        steps.push({index: '2', step: '2', label: 'Adres Bilgileri', icon: 'mdi-map-marker-outline'})
      if (!this.companyInfo.IsExist || !this.creationInfo.IsThereUser)
        steps.push({index: '3', step: '3', label: 'Kullanıcı Bilgileri', icon: 'mdi-account-outline'})
      if (this.selectedModules.includes('ESMM') || this.selectedModules.includes('EArchive'))
        steps.push({index: '4', step: '4', label: 'İmza Seçimi', icon: 'mdi-draw'})
      if (this.selectedModules.includes('EInvoice'))
        steps.push({index: '5', step: '5', label: 'Fatura Bilgileri', icon: 'mdi-file-document-outline'})
      if (this.selectedModules.includes('EDespatch'))
        steps.push({index: '6', step: '6', label: 'İrsaliye Bilgileri', icon: 'mdi-truck-delivery'})
      steps.push({index: '7', step: '8', label: 'Onay', icon: 'mdi-check-decagram'})
      return steps
    },
    currentStepNumber() {
      const position = this.visibleSteps.map(x => x.index).indexOf(String(this.currentStep))
      return position < 0 ? 1 : position + 1
    },
    _companyNameCheck() {
      const {Name, TaxNumber} = this.companyInfo;
      if (Name && TaxNumber && TaxNumber.length === 11) {
        let splitCompanyName = Name.split(" ");
        if (splitCompanyName.length > 1 && splitCompanyName[0].length >= 1 && splitCompanyName[1].length >= 1)
          return true;
        return false;
      }
      return true;
    },
    mailQueryValid() {
      return /^(([a-zA-Z0-9.+*_-]+(\.[a-zA-Z0-9.+*_-]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.companyInfo.User.Email)
    }
  },
  watch: {
    currentStep() {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    signImageInfo: {
      async handler(val) {
        this.companyInfo.ESMMOption = {}
        this.companyInfo.EArchiveOption = {}
        if (this.selectedModules.includes('ESMM')) {
          this.companyInfo.ESMMOption.SignImageBase64 = val.cropImg
        }
        if (this.selectedModules.includes('EArchive')) {
          this.companyInfo.EArchiveOption.SignImageBase64 = val.cropImg
        }
      },
      deep: true
    },
    dealerCodeCheckBoxStatus(val) {
      !val && (this.companyInfo.DealerCode = null)
    }
  }
}
</script>

<style>
.v-list-item__title {
  letter-spacing: 0.05rem;
}

.v-list-item__action {
  display: none !important;
}
</style>
